const names = {
  DEFAULT: 'default',
  CHINESE: 'chinese',
  CYRILIQUE: 'cyrilique',
}

export default names
